import { env } from '@/env.mjs';

type PromoBarPageType = {
    title: string;
    titleRO?: string;
    location?: string;
};

const PROMO_BAR_PAGES: Record<string, PromoBarPageType> = {
    '/': { title: 'Strona główna', titleRO: 'Strona główna RO' },
    '/p/dostepnesklepy/': { title: 'Dostępne sklepy' },
    '/p/magazinepartnere/': {
        title: 'Magazine partenere',
        location: '/p/dostepnesklepy/',
    },
};

export const mapPromoBarPathname = (pathname: string): string =>
    PROMO_BAR_PAGES[pathname]?.location ?? pathname;

export const mapPromoBarPageTitle = (pathname: string): string | undefined => {
    const page = PROMO_BAR_PAGES[pathname];

    if (!page) {
        return undefined;
    }

    return env.NEXT_PUBLIC_APP_COUNTRY === 'RO'
        ? (page.titleRO ?? page.title)
        : page.title;
};
